var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-3 text-center"},[_vm._v(" Sem campos adicionais para produtos ")])}
var staticRenderFns = []

export { render, staticRenderFns }